import { isTenantUuid } from './tenantRoute';
import { setCachedPublicBranding } from 'shared/api/services/publicTenantBrandingService';

const STORAGE_KEY = 'dth_registry_tenant_id';
const SLUG_KEY = 'dth_registry_tenant_slug';

export function setLastLoginTenantId(tenantId) {
  if (typeof window === 'undefined' || !window.sessionStorage) return;
  const normalized = tenantId != null ? String(tenantId).trim() : '';
  if (!normalized || !isTenantUuid(normalized)) return;
  window.sessionStorage.setItem(STORAGE_KEY, normalized);
}

export function getLastLoginTenantId() {
  if (typeof window === 'undefined' || !window.sessionStorage) return null;
  const value = window.sessionStorage.getItem(STORAGE_KEY);
  if (!value || !isTenantUuid(value)) return null;
  return value;
}

/** Human tenant name used in public URLs (e.g. /datahouse). */
export function setLastLoginTenantSlug(tenantName) {
  if (typeof window === 'undefined' || !window.sessionStorage) return;
  const normalized = tenantName != null ? String(tenantName).trim() : '';
  if (!normalized || isTenantUuid(normalized)) return;
  window.sessionStorage.setItem(SLUG_KEY, normalized);
}

export function getLastLoginTenantSlug() {
  if (typeof window === 'undefined' || !window.sessionStorage) return null;
  const value = window.sessionStorage.getItem(SLUG_KEY);
  return value && String(value).trim() ? String(value).trim() : null;
}

export function clearLastLoginTenantId() {
  if (typeof window === 'undefined' || !window.sessionStorage) return;
  window.sessionStorage.removeItem(STORAGE_KEY);
  window.sessionStorage.removeItem(SLUG_KEY);
}

export function rememberTenantFromBranding(branding) {
  if (!branding) return;
  if (branding.id) setLastLoginTenantId(String(branding.id));
  if (branding.name) setLastLoginTenantSlug(branding.name);
  setCachedPublicBranding(branding);
}
